import { render, staticRenderFns } from "./CustomerCostClosure.vue?vue&type=template&id=5b1ce691"
import script from "./CustomerCostClosure.vue?vue&type=script&lang=js"
export * from "./CustomerCostClosure.vue?vue&type=script&lang=js"
import style0 from "./CustomerCostClosure.vue?vue&type=style&index=0&id=5b1ce691&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports